import { GBP_SYMBOL } from "lib/constants";
import React from "react";
import CountUp from "react-countup";
import { FaArrowUp, FaArrowDown } from "react-icons/fa6";
import LoadingBox from "../loading-box";

interface DashboardWidgetProps {
  title: string;
  subTitle?: string;
  description?: string;
  count?: number;
  percentage?: number;
  icon: React.ReactNode;
  total?: number;
  isDashboard?: boolean;
  onClick?: () => void;
  isSelected?: boolean;
  className?: string;
  loading?: boolean;
}

const DashboardWidget: React.FC<DashboardWidgetProps> = ({
  title,
  subTitle,
  description,
  count,
  percentage,
  icon,
  total,
  isDashboard = true,
  isSelected,
  className,
  loading,
  onClick,
}) => {
  const isNegative = percentage < 0;
  const percentageClass = isNegative ? "negative-view" : "passive-view";

  return (
    <div
      className={`${className} cursor-pointer dash-widget ${isSelected ? "selected" : ""
        }`}
      onClick={onClick}
    >
      <div className="dash-boxes comman-flex-center">{icon}</div>
      {loading ? (
        <LoadingBox />
      ) : (
        <div className="dash-content dash-count flex-grow-1">
          {isDashboard ? <h4 className="mb-0">{title}</h4> : <h3>{title}</h3>}
          {subTitle && <small><i>{subTitle}</i></small>}
          <small className="analytics text-end">
            <span>{title === "Earnings" ? GBP_SYMBOL : ""}</span>
            {count ? <CountUp delay={0.4} end={count} duration={0.6} /> : 0}
            {total && (
              <span className="dashboard-widget-total">/{total}</span>
            )}
          </small>
          {percentage ? (
            <p>
              <span className={`rounded-pill ${percentageClass}`}>
                {isNegative ? (
                  <>
                    <FaArrowDown className="icon" /> {Math.abs(percentage)}%
                  </>
                ) : (
                  <>
                    <FaArrowUp className="icon" /> {percentage}%
                  </>
                )}
              </span>
              <span className="mx-1">vs last month</span>
            </p>
          ) : null}
          {description}
        </div>
      )}
    </div>
  );
};

export default DashboardWidget;
